<template>

  <div v-if="platformExchanges" class="table-responsive scrollbar">
    <table class="table table-hover table-sm table-striped fs-10 mb-0">
      <thead class="bg-200">
        <tr>
          <th class="text-900 align-middle white-space-nowrap pe-3 sortable" @click="sortTable('title')">
            Title <span v-html="getSortIcon('title')"></span>
          </th>
          <th class="text-900 align-middle white-space-nowrap pe-3 sortable" @click="sortTable('tradingPair')">
            Trading Pair <span v-html="getSortIcon('tradingPair')"></span>
          </th>
          <th class="text-900 align-middle white-space-nowrap pe-3 sortable" style="min-width: 12.5rem;" @click="sortTable('exchange')">
            Exchange <span v-html="getSortIcon('exchange')"></span>
          </th>
          <th class="text-900 align-middle white-space-nowrap pe-3 sortable" @click="sortTable('accountType')">
            Account Type <span v-html="getSortIcon('accountType')"></span>
          </th>
          <th class="text-900 align-middle white-space-nowrap text-center">
            Status
          </th>
          <th class="no-sort"></th>
        </tr>
      </thead>
      <tbody class="list" id="table-orders-body">
        <tr v-for="bot in sortedBots" :key="bot.id" class="btn-reveal-trigger">
          <td class="py-2 pe-4 align-middle white-space-nowrap text-truncate">
            <router-link :to="{name: 'EditBot', params: {id: bot.id}}"><span class="fw-bold">{{ bot.title }}</span></router-link> <span v-if="bot.category" title="Category">{{ bot.category }}</span>
          </td>
          <td class="py-2 pe-4 align-middle">
            <span class="fw-bold">{{ bot.baseCoin }}/{{ bot.quoteCoin }}</span>
          </td>
          <td class="py-2 pe-4 align-middle white-space-nowrap text-truncate">
            <img class="img-fluid rounded mx-auto" style="height: 30px" :src="`/exchanges/${bot.exchangeId.toLowerCase()}.png`" />&nbsp;
            
            <span class="fw-bold">{{ getExchangeById(bot.exchangeId).name }}</span>
            <span v-if="bot.exchangeId == 'hyperliquid'" lass="text-muted fw-light fs-1">({{ truncateText(bot.exchangeConfig?.publicAddress) }})</span>
            <span v-else lass="text-muted fw-light fs-1">({{ truncateText(bot.exchangeConfig?.apiKey) }})</span>
          </td>
          <td class="py-2 pe-4 align-middle">
            <span class="fw-bold">{{ getAccountType(bot) }}</span>
          </td>
          <td class="py-2 align-middle text-center fs-9 white-space-nowrap text-truncate">
            <span v-if="bot.enabled" class="badge badge rounded-pill d-block badge-subtle-success">Active<span class="ms-1 fas fa-check" data-fa-transform="shrink-2"></span></span>
            <span v-if="!bot.enabled" class="badge badge rounded-pill d-block badge-subtle-secondary">Paused<span class="ms-1 fas fa-pause" data-fa-transform="shrink-2"></span></span>
          </td>
          <td class="py-2 align-middle white-space-nowrap text-truncate text-end">
            <div class="dropdown font-sans-serif position-static">
              <button class="btn btn-link text-600 btn-sm dropdown-toggle btn-reveal" type="button" :id="'dropdown_bot_id_'+bot.id" data-bs-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                <span class="fas fa-ellipsis-h fs-10"></span>
              </button>
              <div class="dropdown-menu dropdown-menu-end border py-0" :aria-labelledby="'dropdown_bot_id_'+bot.id">
                <div class="py-2">
                  <router-link :to="{name: 'EditBot', params: {id: bot.id}}" class="dropdown-item">Edit</router-link>
                  <div class="dropdown-divider"></div>
                  <a v-if="!bot.enabled" @click.prevent="toggleBot(bot, !bot.enabled)" class="dropdown-item text-success" href="#!">Activate</a>
                  <a v-if="bot.enabled" @click.prevent="toggleBot(bot, !bot.enabled)" class="dropdown-item text-warning" href="#!">Pause</a>
                
                  <div v-if="!bot.enabled" class="dropdown-divider"></div>
                  <a v-if="!bot.enabled" @click.prevent="deleteBot(bot)" class="dropdown-item text-danger">Delete</a>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <SimpleModal ref="modalRef" :loading="loading" />

</template>

<script>
import SimpleModal from '@/components/SimpleModal'
import Dropdown from 'bootstrap/js/dist/dropdown.js'

export default {
  props: {
    bots: {
      required: true,
      type: Array
    }
  },
  components: {
    SimpleModal
  },
  data () {
    return {
      loading: false,
      sortBy: 'title',
      sortDirection: 'asc'
    }
  },
  computed: {
    platformExchanges () {
      return this.$store.state.platformExchanges
    },
    sortedBots () {
      const sorted = [...this.bots]
      
      sorted.sort((a, b) => {
        let aVal, bVal
        
        switch(this.sortBy) {
          case 'title':
            aVal = a.title
            bVal = b.title
            break
          case 'tradingPair':
            aVal = `${a.baseCoin}/${a.quoteCoin}`
            bVal = `${b.baseCoin}/${b.quoteCoin}`
            break
          case 'exchange':
            aVal = this.getExchangeById(a.exchangeId).name
            bVal = this.getExchangeById(b.exchangeId).name
            break
          case 'accountType':
            aVal = this.getAccountType(a)
            bVal = this.getAccountType(b)
            break
          default:
            aVal = a.title
            bVal = b.title
        }
        
        if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1
        if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1
        return 0
      })
      
      return sorted
    }
  },
  methods: {
    sortTable(field) {
      if (this.sortBy === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = field
        this.sortDirection = 'asc'
      }
    },
    getSortIcon(field) {
      if (this.sortBy !== field) return '' // Up-down arrow
      return this.sortDirection === 'asc' ? '&#9650;' : '&#9660;' // Up or down triangle
    },
    getExchangeById (id) {
      return this.$store.state.platformExchanges.find(elem => elem.id === id)
    },
    getAccountType (bot) {
      if (bot.tradingAccount == 'spot') {
        return "Spot"
      } else if (bot.tradingAccount == 'perpetual') {
        return "Futures"
      }
    },
    async toggleBot (bot, enabled) {
      let newBot = {
        enabled: enabled,
        id: bot.id
      }

      this.$refs.modalRef.setValues({
        title: (enabled)? 'Activate Bot?' : 'Pause Bot?',
        message: (enabled)? 'Are you sure you want to activate your <span class="fw-bold">"'+bot.title+'"</span> Bot?' : 'Are you sure you want to pause your <span class="fw-bold">"'+bot.title+'"</span> Bot?',
        callback: async () => {
          this.loading = true
          await this.$store.dispatch('updateBot', newBot)
          this.loading = false
          // TODO: Handle errors and show them somewhere!!!
        }
      })

      this.$refs.modalRef.toggleModal(true)
    },
    async deleteBot (bot) {
      this.$refs.modalRef.setValues({
        title: 'Delete Bot?',
        message: 'Are you sure you want to delete your <span class="fw-bold">"'+bot.title+'"</span> Bot? <br><br>This action cannot be undone!',
        callback: async () => {
          this.loading = true
          await await this.$store.dispatch('deleteBot', bot)
          this.loading = false
          // TODO: Handle errors and show them somewhere!!!
        }
      })

      this.$refs.modalRef.toggleModal(true)
    },
    truncateText(text) {
      let truncatedText = text.substring(0, 20)
      if (truncatedText.length < text.length) truncatedText = truncatedText + "..."
      return truncatedText
    }
  },
  async created () {
    // TODO: Get's called for each BotList we invoke - atm. it's 2 times for active and paused Bots
    if (!this.$store.state.platformExchanges) await this.$store.dispatch('getPlatformExchanges')
  },
  mounted () {
    // Initialize all dropdowns
    var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
    dropdownElementList.map(function (dropdownToggleEl) {
      return new Dropdown(dropdownToggleEl)
    })
  }
}
</script>

<style scoped>
.table tr td {
  border-style: none;
}
.dropdown-menu {
  z-index: 9999;
}
.sortable {
  cursor: pointer;
  user-select: none;
}
.sortable:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>